module.exports = __webpack_public_path__ + "static/checkout-payments-f6fd785732da57c56e5ea2abb24127d9.svg";